export default function mapToPlainObject<T, V>(
  input: Map<string, T>,
  valueTransformer: (arg0: T) => V,
): ObjectOf<V> {
  let object: ObjectOf<V> = {};
  for (let [key, value] of input) {
    object[key] = valueTransformer(value);
  }
  return object;
}
